import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
// import './static/scss/library/bootstrap.min.css';
import './static/scss/mobile/category-page.scss';
import './static/fonts/ajioicon/category-icons.woff';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import CategoryPage from './components/mobile/category/Category';
// import NotFoundPage from './components/mobile/NotFoundPage';
import { getPeFlag } from './Flags/selectors';

const routes = props => (
  <Router>
    <Switch>
      <Route path="/c/:searchInput" component={CategoryPage} />
      <Route path="/fc/:searchInput" component={CategoryPage} />
      <Route path="/:categoryName/c/:searchInput" component={CategoryPage} />
      <Route path="/b/:searchInput" component={CategoryPage} />
      <Route path="/fb/:searchInput" component={CategoryPage} />
      <Route path="/s/:searchInput" component={CategoryPage} />
      <Route path="/s1/:searchInput" component={CategoryPage} />
      <Route path="/search/:searchInput" component={CategoryPage} />
      <Route path="/search" component={CategoryPage} />
      <Route path="/find/:searchInput" component={CategoryPage} />
      <Route path="/find" component={CategoryPage} />
      {/* <Route component={NotFoundPage} /> */}
    </Switch>
  </Router>
);

const mapStateToProps = state => {
  const { flags = {} } = state;
  return {
    peFlag: getPeFlag(flags)
  };
};

export default connect(mapStateToProps)(routes);
